import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    BusinessType: state.components.contactUsForm.fieldValues["BusinessType"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface BusinessTypeStyles {
    businessTypeTextField?: TextFieldPresentationProps;
}

export const BusinessTypeStyles: BusinessTypeStyles = {
    businessTypeTextField: {
        css: css`
            border-radius: 8px !important;
        `,
        cssOverrides: {
            formField: css`
                margin-bottom: 20px;
            `,

            formInputWrapper: css`
                margin-top: 4px!important;
            `,
        },
    },
};

const styles = BusinessTypeStyles;

const BusinessType: React.FC<Props> = ({ fields, BusinessType, setFieldValue }) => {
    const { label, hintText, isRequired } = fields;
    const contactFormContext = React.useContext(ContactFormContext);
    const [BusinessTypeErrorMessage, setBusinessTypeErrorMessage] = React.useState("");

    React.useEffect(() => {
        contactFormContext.validators.BusinessType = validateBusinessType;
        if (typeof BusinessType !== "undefined") {
            validateBusinessType();
        }
    }, [BusinessType]);

    React.useEffect(() => {
        contactFormContext.validators.BusinessType = validateBusinessType;
    }, [isRequired]);

    const validateBusinessType = () => {
        const errorMessage = isRequired && !BusinessType ? (siteMessage("Field_Required", label) as string) : "";
        setBusinessTypeErrorMessage(errorMessage);
        return !errorMessage;
    };

    const BusinessTypeChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "BusinessType", value: event.target.value });
    };

    return (
        <TextField
            {...styles.businessTypeTextField}
            label={label}
            placeholder={hintText}
            required={isRequired}
            value={BusinessType || ""}
            error={BusinessTypeErrorMessage}
            onChange={BusinessTypeChangeHandler}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(BusinessType),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        displayName: "BusinessType",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
                isRequired: false,
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
